var React = require('react');

function LinkedinWhiteIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.454 23.834V8.072H.164v15.762h5.29zm0-21.35C5.423 1.075 4.402 0 2.743 0 1.084 0 0 1.074 0 2.485 0 3.865 1.052 4.97 2.68 4.97h.031c1.69 0 2.743-1.105 2.743-2.485zm8.632 21.35v-8.98c0-.481.037-.962.19-1.304.42-.961 1.376-1.956 2.98-1.956 2.1 0 3.418 1.098 3.418 3.26v8.98H26v-9.22c0-4.94-2.864-7.239-6.683-7.239-3.132 0-4.507 1.612-5.27 2.71l.038-2.108H8.768c.076 1.509 0 15.857 0 15.857h5.318z","fill":"#FAFAFA"}));
}

LinkedinWhiteIcon.defaultProps = {"width":"26","height":"24","fill":"none"};

module.exports = LinkedinWhiteIcon;

LinkedinWhiteIcon.default = LinkedinWhiteIcon;
